import permissions from './permissions.json'

export enum Resource {
  Projects = 'projects',
  ProjectRequests = 'project_request',
  ProjectMembers = 'project_members',
  ProjectModuleMember = 'project_module_member',
  ProjectModuleAccess = 'project_module_access',
  Mockups = 'mockups',
  Templates = 'templates',
  Supporters = 'supporters',
  Analytics = 'analytics',
  News = 'news',
  Comment = 'comment',
  Surveys = 'surveys',
  Counters = 'counters',
  ProjectCustomModule = 'project_custom_module',
}

export const resourceAccess = {
  [Resource.Projects]: { createAll: 'project:create:all', listAll: 'project:list:all', listOwn: 'project:list:own', listProject: 'project:list:project', readAll: 'project:read:all', readOwn: 'project:read:own', readProject: 'project:read:project', updateAll: 'project:update:all', updateOwn: 'project:update:own', updateProject: 'project:update:project', deleteAll: 'project:delete:all', deleteOwn: 'project:delete:own' },
  [Resource.ProjectRequests]: { createOwn: 'project_request:create_own', manage: 'project_request:manage', presignedUrl: 'project_request:presigned_url', readAll: 'project_request:read_all', readOwn: 'project_request:read_own', updateOwn: 'project_request:update_own' },
  [Resource.ProjectMembers]: { createAll: 'project_member:create:all', createProject: 'project_member:create:project', deleteAll: 'project_member:delete:all', deleteOwn: 'project_member:delete:own', deleteProject: 'project_member:delete:project', listAll: 'project_member:list:all', listProject: 'project_member:list:project', readAll: 'project_member:read:all', readOwn: 'project_member:read:own', readProject: 'project_member:read:project', updateAll: 'project_member:update:all', updateProject: 'project_member:update:project' },
  [Resource.ProjectModuleMember]: { createAll: 'project_module_member:create:all', createProject: 'project_module_member:create:project', deleteProject: 'project_module_member:delete:project', listAll: 'project_module_member:list:all', listProject: 'project_module_member:list:project', readAll: 'project_module_member:read:all', readProject: 'project_module_member:read:project', updateAll: 'project_module_member:update:all', updateProject: 'project_module_member:update:project' },
  [Resource.ProjectModuleAccess]: { readProject: 'project_module_access:read:project', updateProject: 'project_module_access:update:project' },
  [Resource.Mockups]: { read: 'mockup:read', create: 'mockup:create', update: 'mockup:update', delete: 'mockup:delete' },
  [Resource.Templates]: { read: 'template:read', create: 'template:create', update: 'template:update', delete: 'template:delete' },
  [Resource.Supporters]: { createProject: 'supporter:create:project', deleteProject: 'supporter:delete:project', exportAll: 'supporter:export:all', exportProject: 'supporter:export:project', listAll: 'supporter:list:all', listProject: 'supporter:list:project', notifyAll: 'supporter:notify:all', notifyProject: 'supporter:notify:project', readAll: 'supporter:read:all', readProject: 'supporter:read:project', updateProject: 'supporter:update:project' },
  [Resource.Analytics]: { generate: 'analytics:generate', read: 'analytics:read' },
  [Resource.News]: { createAll: 'news:create:all', createOwn: 'news:create:own', createProject: 'news:create:project', deleteAll: 'news:delete:all', deleteOwn: 'news:delete:own', deleteProject: 'news:delete:project', listAll: 'news:list:all', listOwn: 'news:list:own', listProject: 'news:list:project', readAll: 'news:read:all', readOwn: 'news:read:own', readProject: 'news:read:project', updateAll: 'news:update:all', updateOwn: 'news:update:own', updateProject: 'news:update:project' },
  [Resource.Comment]: { createAll: 'comment:create:all', deleteAll: 'comment:delete:all', listAll: 'comment:list:all', readAll: 'comment:read:all', updateAll: 'comment:update:all', updateOwn: 'comment:update:own' },
  [Resource.Counters]: {
    create: 'counter:create:project',
    delete: 'counter:delete:project',
    list: 'counter:list:project',
    read: 'counter:read:project',
    update: 'counter:update:project',
    viewPermissions: 'counter:view_permissions',
    readingCreate: 'counter_reading:create:project',
    readingDelete: 'counter_reading:delete:project',
    readingList: 'counter_reading:list:project',
    readingRead: 'counter_reading:read:project',
    readingUpdate: 'counter_reading:update:project',
  },
  [Resource.Surveys]: {
    archiveAll: 'survey:archive:all',
    archiveOwn: 'survey:archive:own',
    createAll: 'survey:create:all',
    createOwn: 'survey:create:own',
    deleteAll: 'survey:delete:all',
    deleteOwn: 'survey:delete:own',
    listActive: 'survey:list:active',
    listAll: 'survey:list:all',
    listArchived: 'survey:list:archived',
    listDeleted: 'survey:list:deleted',
    listOwn: 'survey:list:own',
    publicLinkAll: 'survey:public_link:all',
    publicLinkOwn: 'survey:public_link:own',
    publishAll: 'survey:publish:all',
    publishOwn: 'survey:publish:own',
    questionUpdateAll: 'survey:question:update:all',
    questionUpdateOwn: 'survey:question:update:own',
    readAll: 'survey:read:all',
    readOwn: 'survey:read:own',
    recoverAll: 'survey:recover:all',
    recoverOwn: 'survey:recover:own',
    scheduleAll: 'survey:schedule:all',
    scheduleOwn: 'survey:schedule:own',
    statsAll: 'survey:stats:all',
    statsOwn: 'survey:stats:own',
    updateAll: 'survey:update:all',
    updateOwn: 'survey:update:own',
    viewPermissions: 'survey:view_permissions',
    visibilityAll: 'survey:visibility:all',
    visibilityOwn: 'survey:visibility:own',
  },
  [Resource.ProjectCustomModule]: {
    createProject: 'custom_module:create:project',
    readProject: 'custom_module:read:project',
    updateProject: 'custom_module:update:project',
    deleteAll: 'custom_module:delete:all',
    deleteProject: 'custom_module:delete:project',
    listProject: 'custom_module:list:project',
    viewPermissions: 'custom_module:view_permissions',
  },
}

export const frontendPermissions = {
  [permissions.ADMIN.REPORTS.PERMISSION]: {
    resources: [Resource.Analytics],
    access: [resourceAccess[Resource.Analytics].read],
  },
  [permissions.ADMIN.REPORTS.SUPPORTERS.PERMISSION]: {
    resources: [Resource.Analytics],
    access: [resourceAccess[Resource.Analytics].read],
  },
  [permissions.ADMIN.REPORTS.SUPPORTERS.PROJECTS.PERMISSION]: {
    resources: [Resource.Analytics],
    access: [resourceAccess[Resource.Analytics].read],
  },
  [permissions.ADMIN.REPORTS.SUPPORTERS.PROJECTS.TEMPLATES.PERMISSION]: {
    resources: [Resource.Analytics],
    access: [resourceAccess[Resource.Analytics].read],
  },
  [permissions.ADMIN.REPORTS.SUPPORTERS.PROJECTS.TEMPLATES.CREATE.PERMISSION]: {
    resources: [Resource.Analytics],
    access: [resourceAccess[Resource.Analytics].read],
  },
  [permissions.ADMIN.REPORTS.SUPPORTERS.PROJECTS.SEND_MESSAGE.PERMISSION]: {
    resources: [Resource.Analytics],
    access: [resourceAccess[Resource.Analytics].read],
  },
  [permissions.PROJECTS.WORKSPACE.SUPPORTERS.PERMISSION]: {
    resources: [Resource.Supporters],
    access: [resourceAccess[Resource.Supporters].listProject, resourceAccess[Resource.Supporters].listAll],
  },
  [permissions.PROJECTS.WORKSPACE.SUPPORTERS.CREATE.PERMISSION]: {
    resources: [Resource.Supporters],
    access: [resourceAccess[Resource.Supporters].createProject],
  },
  [permissions.PROJECTS.WORKSPACE.SUPPORTERS.SHOW_CREATE_SUPPORTER_BTN.PERMISSION]: {
    resources: [Resource.Supporters],
    access: [resourceAccess[Resource.Supporters].createProject],
  },
  [permissions.PROJECTS.WORKSPACE.SUPPORTERS.SHOW_EDIT_SUPPORTER_BTN.PERMISSION]: {
    resources: [Resource.Supporters],
    access: [resourceAccess[Resource.Supporters].updateProject],
  },
  [permissions.PROJECTS.WORKSPACE.SUPPORTERS.SHOW_DELETE_SUPPORTER_BTN.PERMISSION]: {
    resources: [Resource.Supporters],
    access: [resourceAccess[Resource.Supporters].deleteProject],
  },
  [permissions.PROJECTS.WORKSPACE.SUPPORTERS.EDIT.PERMISSION]: {
    resources: [Resource.Supporters],
    access: [resourceAccess[Resource.Supporters].readProject, resourceAccess[Resource.Supporters].updateProject],
  },
  [permissions.PROJECTS.WORKSPACE.SUPPORTERS.REPORT.PERMISSION]: {
    resources: [Resource.Supporters],
    access: [resourceAccess[Resource.Supporters].listProject, resourceAccess[Resource.Supporters].listAll],
  },
  [permissions.PROJECTS.WORKSPACE.SUPPORTERS.REPORT.TEMPLATES.PERMISSION]: {
    resources: [Resource.Supporters, Resource.Mockups],
    access: [resourceAccess[Resource.Supporters].listProject, resourceAccess[Resource.Supporters].listAll],
  },
  [permissions.PROJECTS.WORKSPACE.SUPPORTERS.REPORT.TEMPLATES.CREATE.PERMISSION]: {
    resources: [Resource.Supporters],
    access: [resourceAccess[Resource.Supporters].listAll, resourceAccess[Resource.Supporters].listProject],
  },
  [permissions.PROJECTS.WORKSPACE.SUPPORTERS.REPORT.SEND_MESSAGE.PERMISSION]: {
    resources: [Resource.Supporters],
  },
  [permissions.PROJECTS.WORKSPACE.SUPPORTERS.REPORT.SHOW_EXPORT_REPORT_BTN.PERMISSION]: {
    resources: [Resource.Supporters],
    access: [resourceAccess[Resource.Supporters].exportProject],
  },
  [permissions.PROJECTS.WORKSPACE.SUPPORTERS.SHOW_DELETE_SUPPORTER_BTN.PERMISSION]: {
    resources: [Resource.Supporters],
    access: [resourceAccess[Resource.Supporters].deleteProject],
  },
  [permissions.PROJECTS.REQUESTS.PERMISSION]: {
    resources: [Resource.ProjectRequests],
  },
  [permissions.PROJECTS.WORKSPACE.MEMBERS.PERMISSION]: {
    resources: [Resource.ProjectMembers],
    access: [resourceAccess[Resource.ProjectMembers].listProject, resourceAccess[Resource.ProjectMembers].listAll],
  },
  [permissions.PROJECTS.WORKSPACE.MEMBERS.SHOW_DELETE_MEMBER.PERMISSION]: {
    resources: [Resource.ProjectMembers],
    access: [resourceAccess[Resource.ProjectMembers].deleteAll, resourceAccess[Resource.ProjectMembers].deleteProject],
  },
  [permissions.PROJECTS.WORKSPACE.MEMBERS.SHOW_ADD_MEMBER.PERMISSION]: {
    resources: [Resource.ProjectMembers],
    access: [resourceAccess[Resource.ProjectMembers].createAll, resourceAccess[Resource.ProjectMembers].createProject],
  },
  [permissions.PROJECTS.WORKSPACE.MEMBERS.INVITE.PERMISSION]: {
    resources: [Resource.ProjectMembers],
    access: [resourceAccess[Resource.ProjectMembers].listAll, resourceAccess[Resource.ProjectMembers].listProject],
  },
  [permissions.PROJECTS.REQUESTS.APPROVAL.PERMISSION]: {
    resources: [Resource.ProjectRequests],
    access: [resourceAccess[Resource.ProjectRequests].manage],
  },
  [permissions.PROJECTS.REQUESTS.GET_ALL_REQUESTS.PERMISSION]: {
    resources: [Resource.ProjectRequests],
    access: [resourceAccess[Resource.ProjectRequests].readAll],
  },
  [permissions.PROJECTS.REQUESTS.CREATE.ONLY_PROJECT.PERMISSION]: {
    resources: [Resource.ProjectRequests],
    access: [resourceAccess[Resource.ProjectRequests].manage],
  },
  [permissions.PROJECTS.REQUESTS.CREATE.PERMISSION]: {
    resources: [Resource.ProjectRequests],
    access: [resourceAccess[Resource.ProjectRequests].createOwn],
  },
  [permissions.PROJECTS.REQUESTS.WORKSPACE_PRESET_SELECT.PERMISSION]: {
    resources: [Resource.ProjectRequests],
    access: [resourceAccess[Resource.ProjectRequests].createOwn],
  },
  [permissions.PROJECTS.REQUESTS.SHOW_NAVIGATION_BUTTON.PERMISSION]: {
    resources: [Resource.ProjectRequests],
    access: [resourceAccess[Resource.ProjectRequests].manage],
  },
  [permissions.PROJECTS.WORKSPACE.MANAGEMENTS.MY_TEAM.PERMISSION]: {
    resources: [Resource.ProjectMembers],
    access: [resourceAccess[Resource.ProjectMembers].listAll, resourceAccess[Resource.ProjectMembers].listProject],
  },
  [permissions.PROJECTS.WORKSPACE.MANAGEMENTS.MY_TEAM.ADD.PERMISSION]: {
    resources: [Resource.ProjectMembers],
    access: [resourceAccess[Resource.ProjectMembers].listAll, resourceAccess[Resource.ProjectMembers].listProject],
  },
  [permissions.PROJECTS.WORKSPACE.MANAGEMENTS.MY_TEAM.PROFILE.PERMISSION]: {
    resources: [Resource.ProjectMembers, Resource.ProjectModuleMember],
    access: [resourceAccess[Resource.ProjectMembers].readAll, resourceAccess[Resource.ProjectMembers].readProject],
  },
  [permissions.PROJECTS.WORKSPACE.SUPPORTERS.REPORT.TEMPLATES.EDIT.PERMISSION]: {
    resources: [Resource.Supporters],
    access: [resourceAccess[Resource.Supporters].listAll, resourceAccess[Resource.Supporters].listProject],
  },
  [permissions.PROJECTS.WORKSPACE.SUPPORTERS.REPORT.TEMPLATES.SHOW_ADD_MOCKUP_BTN.PERMISSION]: {
    resources: [Resource.Supporters],
    access: [resourceAccess[Resource.Supporters].listAll, resourceAccess[Resource.Supporters].listProject],
  },
  [permissions.PROJECTS.WORKSPACE.SUPPORTERS.REPORT.TEMPLATES.SHOW_ADD_TEMPLATE_BTN.PERMISSION]: {
    resources: [Resource.Supporters],
    access: [resourceAccess[Resource.Supporters].listAll, resourceAccess[Resource.Supporters].listProject],
  },
  [permissions.ADMIN.REPORTS.SUPPORTERS.PROJECTS.TEMPLATES.SHOW_ADD_MOCKUP_BTN.PERMISSION]: {
    resources: [Resource.Analytics],
    access: [resourceAccess[Resource.Analytics].read],
  },
  [permissions.ADMIN.REPORTS.SUPPORTERS.PROJECTS.TEMPLATES.SHOW_ADD_TEMPLATE_BTN.PERMISSION]: {
    resources: [Resource.Analytics],
    access: [resourceAccess[Resource.Analytics].read],
  },
  [permissions.ADMIN.REPORTS.SUPPORTERS.PROJECTS.TEMPLATES.EDIT.PERMISSION]: {
    resources: [Resource.Analytics],
    access: [resourceAccess[Resource.Analytics].read],
  },
  [permissions.PROJECTS.REQUESTS.EDIT.PERMISSION]: {
    resources: [Resource.ProjectRequests],
    access: [resourceAccess[Resource.ProjectRequests].updateOwn],
  },
  [permissions.PROJECTS.PROJECT.PERMISSION]: {
    resources: [Resource.Projects, Resource.Templates],
    access: [
      resourceAccess[Resource.Projects].readAll,
      resourceAccess[Resource.Projects].readOwn,
      resourceAccess[Resource.Projects].readProject,
    ],
  },
  [permissions.PROJECTS.WORKSPACE.PERMISSION]: {
    resources: [Resource.Projects, Resource.ProjectCustomModule],
    access: [resourceAccess[Resource.Projects].readAll, resourceAccess[Resource.Projects].readOwn, resourceAccess[Resource.Projects].readProject],
  },
  [permissions.PROJECTS.WORKSPACE.ABOUT.PERMISSION]: {
    resources: [Resource.Projects],
    access: [resourceAccess[Resource.Projects].readAll, resourceAccess[Resource.Projects].readOwn, resourceAccess[Resource.Projects].readProject],
  },
  [permissions.PROJECTS.WORKSPACE.ABOUT.EDIT.PERMISSION]: {
    resources: [Resource.Projects],
    access: [resourceAccess[Resource.Projects].updateAll, resourceAccess[Resource.Projects].updateOwn, resourceAccess[Resource.Projects].updateProject],
  },
  [permissions.PROJECTS.WORKSPACE.MANAGEMENTS.SETTINGS.PERMISSION]: {
    resources: [Resource.Projects],
    access: [resourceAccess[Resource.Projects].updateAll, resourceAccess[Resource.Projects].updateOwn, resourceAccess[Resource.Projects].updateProject, resourceAccess[Resource.Projects].deleteAll, resourceAccess[Resource.Projects].deleteOwn],
  },
  [permissions.PROJECTS.WORKSPACE.MANAGEMENTS.PERMISSION]: {

  },
  [permissions.PROJECTS.WORKSPACE.MANAGEMENTS.MODULE.PERMISSION]: {
    resources: [Resource.Projects],
    access: [
      resourceAccess[Resource.Projects].readProject,
      resourceAccess[Resource.Projects].readOwn,
    ],
  },
  [permissions.PROJECTS.WORKSPACE.MANAGEMENTS.MY_TEAM.PROFILE.MODULE.PERMISSION]: {
    resources: [Resource.Projects],
    access: [resourceAccess[Resource.Projects].readProject],
  },
  [permissions.PROJECTS.WORKSPACE.MANAGEMENTS.MY_TEAM.PROFILE.MODULE.DETAIL.PERMISSION]: {
    resources: [Resource.Projects],
    access: [
      resourceAccess[Resource.Projects].readProject,
      resourceAccess[Resource.Projects].readOwn,
    ],
  },
  [permissions.PROJECTS.WORKSPACE.MANAGEMENTS.MODULE.DETAIL.PERMISSION]: {
    resources: [Resource.Projects],
    access: [
      resourceAccess[Resource.Projects].readProject,
      resourceAccess[Resource.Projects].readOwn,
      resourceAccess[Resource.Projects].updateProject,
      resourceAccess[Resource.Projects].updateOwn,
    ],
  },
  [permissions.PROJECTS.WORKSPACE.MANAGEMENTS.MY_TEAM.PROFILE.SHOW_EDIT_MODULES_BTN.PERMISSION]: {
    resources: [Resource.ProjectModuleMember],
    access: [resourceAccess[Resource.ProjectModuleMember].createAll, resourceAccess[Resource.ProjectModuleMember].createProject, resourceAccess[Resource.ProjectModuleMember].deleteProject],
  },
  [permissions.PROJECTS.WORKSPACE.SUPPORTERS.MERGE_LIST.PERMISSION]: {
    resources: [Resource.Supporters],
    access: [resourceAccess[Resource.Supporters].listProject],
  },
  [permissions.PROJECTS.WORKSPACE.SUPPORTERS.REPORT.SHARE_SUPPORTERS.PERMISSION]: {
    resources: [Resource.Supporters],
    access: [resourceAccess[Resource.Supporters].listProject],
  },
  [permissions.PROJECTS.WORKSPACE.ABOUT.SHOW_SELECTION_TEMPLATE_BTN.PERMISSION]: {
    resources: [Resource.Projects],
    access: [resourceAccess[Resource.Projects].listOwn, resourceAccess[Resource.Projects].readOwn, resourceAccess[Resource.Projects].updateOwn],
  },
  [permissions.PROJECTS.WORKSPACE.ABOUT.SHOW_SELECTION_EDIT_TEMPLATE_BTN.PERMISSION]: {
    resources: [Resource.Projects],
    access: [resourceAccess[Resource.Projects].listOwn, resourceAccess[Resource.Projects].readOwn, resourceAccess[Resource.Projects].updateOwn],
  },
  [permissions.PROJECTS.WORKSPACE.SURVEYS.PERMISSION]: {
    resources: [Resource.ProjectMembers, Resource.Surveys],
  },
  [permissions.PROJECTS.WORKSPACE.SURVEYS.SHOW_SHARE_LINK_BTN.PERMISSION]: {
    resources: [Resource.Surveys],
    access: [resourceAccess[Resource.ProjectMembers].listProject, resourceAccess[Resource.Surveys].publicLinkAll, resourceAccess[Resource.Surveys].publicLinkOwn],
  },
  [permissions.PROJECTS.WORKSPACE.SURVEYS.SHOW_EDIT_LINK_BTN.PERMISSION]: {
    resources: [Resource.Surveys],
    access: [resourceAccess[Resource.ProjectMembers].listProject, resourceAccess[Resource.Surveys].updateAll, resourceAccess[Resource.Surveys].updateOwn],
  },
  [permissions.PROJECTS.WORKSPACE.SURVEYS.SHOW_ARCHIVE_LINK_BTN.PERMISSION]: {
    resources: [Resource.Surveys],
    access: [resourceAccess[Resource.ProjectMembers].listProject, resourceAccess[Resource.Surveys].archiveAll, resourceAccess[Resource.Surveys].archiveOwn],
  },
  [permissions.PROJECTS.WORKSPACE.SURVEYS.SHOW_CREATE_SURVEY_BTN.PERMISSION]: {
    resources: [Resource.Surveys],
    access: [resourceAccess[Resource.Surveys].createAll, resourceAccess[Resource.Surveys].createOwn],
  },
  [permissions.PROJECTS.WORKSPACE.SURVEYS.SHOW_STATISTICS_TAB.PERMISSION]: {
    resources: [Resource.Surveys],
    access: [resourceAccess[Resource.Surveys].statsAll, resourceAccess[Resource.Surveys].statsOwn],
  },
  [permissions.PROJECTS.WORKSPACE.SURVEYS.SHOW_ARCHIVE_TAB.PERMISSION]: {
    resources: [Resource.Surveys],
    access: [resourceAccess[Resource.Surveys].listArchived],
  },
  [permissions.PROJECTS.WORKSPACE.SURVEYS.CREATE.PERMISSION]: {
    resources: [Resource.Surveys],
    access: [resourceAccess[Resource.Surveys].createAll, resourceAccess[Resource.Surveys].createOwn],
  },
  [permissions.PROJECTS.WORKSPACE.SURVEYS.EDIT.PERMISSION]: {
    resources: [Resource.Surveys],
    access: [resourceAccess[Resource.Surveys].updateAll, resourceAccess[Resource.Surveys].updateOwn],
  },
  [permissions.NEWS.PERMISSION]: {
    resources: [Resource.News],
    access: [resourceAccess[Resource.News].listAll, resourceAccess[Resource.News].listOwn, resourceAccess[Resource.News].listProject],
  },
  [permissions.PROJECTS.WORKSPACE.NEWS.PERMISSION]: {
    resources: [Resource.News],
    access: [resourceAccess[Resource.News].listAll, resourceAccess[Resource.News].listOwn, resourceAccess[Resource.News].listProject],
  },
  [permissions.NEWS.CREATE.PERMISSION]: {
    resources: [Resource.News],
    access: [resourceAccess[Resource.News].createAll, resourceAccess[Resource.News].createOwn, resourceAccess[Resource.News].createProject],
  },
  [permissions.NEWS.CREATE.SELECT_PROJECT.PERMISSION]: {
    resources: [Resource.News],
    access: [resourceAccess[Resource.News].createProject, resourceAccess[Resource.News].createOwn, resourceAccess[Resource.News].createAll],
  },
  [permissions.NEWS.EDIT.PERMISSION]: {
    resources: [Resource.News],
    access: [resourceAccess[Resource.News].readAll, resourceAccess[Resource.News].readOwn, resourceAccess[Resource.News].readProject, resourceAccess[Resource.News].updateAll, resourceAccess[Resource.News].updateOwn, resourceAccess[Resource.News].updateProject],
  },
  [permissions.NEWS.DETAIL.PERMISSION]: {
    resources: [Resource.News],
    access: [resourceAccess[Resource.News].readProject, resourceAccess[Resource.News].readOwn, resourceAccess[Resource.News].readAll],
  },
  [permissions.NEWS.COMMENTS.PERMISSION]: {
    resources: [Resource.Comment],
    // access: [resourceAccess[Resource.News].updateProject],
  },
  [permissions.PROJECTS.WORKSPACE.NEWS.CREATE.PERMISSION]: {
    resources: [Resource.News],
    access: [resourceAccess[Resource.News].createAll, resourceAccess[Resource.News].createOwn, resourceAccess[Resource.News].createProject],
  },
  [permissions.PROJECTS.WORKSPACE.NEWS.EDIT.PERMISSION]: {
    resources: [Resource.News],
    access: [resourceAccess[Resource.News].readAll, resourceAccess[Resource.News].readOwn, resourceAccess[Resource.News].readProject, resourceAccess[Resource.News].updateAll, resourceAccess[Resource.News].updateOwn, resourceAccess[Resource.News].updateProject],
  },
  [permissions.PROJECTS.WORKSPACE.NEWS.DETAIL.PERMISSION]: {
    resources: [Resource.News],
    access: [resourceAccess[Resource.News].readAll, resourceAccess[Resource.News].readOwn, resourceAccess[Resource.News].readProject],
  },
  [permissions.PROJECTS.WORKSPACE.MY_SPEECH.SPEECH_REVIEW.PERMISSION]: {
    resources: [Resource.News],
    access: [
      resourceAccess[Resource.News].readAll,
      resourceAccess[Resource.News].readProject,
      resourceAccess[Resource.News].updateAll,
      resourceAccess[Resource.News].updateProject,
    ],
  },
  [permissions.PROJECTS.WORKSPACE.NEWS.COMMENTS.PERMISSION]: {
    resources: [Resource.Comment],
    // access: [resourceAccess[Resource.News].updateProject],
  },
  [permissions.PROJECTS.WORKSPACE.NEWS.SHOW_CREATE_NEWS_BTN.PERMISSION]: {
    resources: [Resource.News],
    access: [resourceAccess[Resource.News].createProject, resourceAccess[Resource.News].createOwn, resourceAccess[Resource.News].createAll],
  },
  [permissions.PROJECTS.WORKSPACE.NEWS.SHOW_DELETE_NEWS_BTN.PERMISSION]: {
    resources: [Resource.News],
    access: [resourceAccess[Resource.News].deleteAll, resourceAccess[Resource.News].deleteOwn, resourceAccess[Resource.News].deleteProject],
  },
  [permissions.PROJECTS.WORKSPACE.NEWS.SHOW_EDIT_NEWS_BTN.PERMISSION]: {
    resources: [Resource.News],
    access: [resourceAccess[Resource.News].updateAll, resourceAccess[Resource.News].updateOwn, resourceAccess[Resource.News].updateProject],
  },
  [permissions.NEWS.SHOW_CREATE_NEWS_BTN.PERMISSION]: {
    resources: [Resource.News],
    access: [resourceAccess[Resource.News].createAll, resourceAccess[Resource.News].createProject],
  },
  [permissions.NEWS.SHOW_DELETE_NEWS_BTN.PERMISSION]: {
    resources: [Resource.News],
    access: [resourceAccess[Resource.News].deleteAll, resourceAccess[Resource.News].deleteProject],
  },
  [permissions.NEWS.SHOW_EDIT_NEWS_BTN.PERMISSION]: {
    resources: [Resource.News],
    access: [resourceAccess[Resource.News].updateAll, resourceAccess[Resource.News].updateProject],
  },
  [permissions.PROJECTS.WORKSPACE.COUNTERS.PERMISSION]: {
    resources: [Resource.Counters],
    access: [resourceAccess[Resource.Counters].list, resourceAccess[Resource.Counters].readingList],
  },
  [permissions.PROJECTS.WORKSPACE.COUNTERS.DETAIL.PERMISSION]: {
    resources: [Resource.Counters],
    access: [resourceAccess[Resource.Counters].read, resourceAccess[Resource.Counters].readingRead, resourceAccess[Resource.Counters].readingCreate],
  },
  [permissions.PROJECTS.WORKSPACE.COUNTERS.HISTORY.PERMISSION]: {
    resources: [Resource.Counters],
    access: [resourceAccess[Resource.Counters].readingRead, resourceAccess[Resource.Counters].readingCreate],
  },
  [permissions.WORKSPACE.CALENDAR.PERMISSION]: {
    resources: [],
  },
  [permissions.PROJECTS.WORKSPACE.CALENDAR.PERMISSION]: {
    resources: [],
  },
  [permissions.PROJECTS.WORKSPACE.CALENDAR.TASK_PARTICIPANTS.PERMISSION]: {
    resources: [],
  },
  [permissions.PROJECTS.WORKSPACE.CALENDAR.TASK_COMMENTS.PERMISSION]: {
    resources: [],
  },
  [permissions.PROJECTS.WORKSPACE.CALENDAR.TASK_INVITATIONS.PERMISSION]: {
    resources: [],
  },
  [permissions.PROJECTS.WORKSPACE.MODULE_CREATE_SELECT.PERMISSION]: {
    resources: [Resource.ProjectCustomModule],
    access: [resourceAccess[Resource.ProjectCustomModule].createProject],
  },
  [permissions.PROJECTS.WORKSPACE.CUSTOM_MODULE_CREATE.PERMISSION]: {
    resources: [Resource.ProjectCustomModule],
    access: [resourceAccess[Resource.ProjectCustomModule].createProject],
  },
  [permissions.PROJECTS.WORKSPACE.SHOW_ADD_CUSTOM_MODULE_BTN.PERMISSION]: {
    resources: [Resource.ProjectCustomModule],
    access: [resourceAccess[Resource.ProjectCustomModule].createProject],
  },
  [permissions.PROJECTS.WORKSPACE.SHOW_DELETE_CUSTOM_MODULE_BTN.PERMISSION]: {
    resources: [Resource.ProjectCustomModule],
    access: [
      resourceAccess[Resource.ProjectCustomModule].deleteAll,
      resourceAccess[Resource.ProjectCustomModule].deleteProject,
    ],
  },
}
